import React from 'react';
import { Button, Flex, Typography } from '../common';
import { useThemeContext } from '../../theme/GlobalTheme';
import { useNavigate } from 'react-router-dom';
import { TC_CONFIG } from '../../constants';

const TermsAndConditions = () => {
  const { isDark } = useThemeContext();
  const navigate = useNavigate();
  return (
    <Flex vertical className=" pt-10 ">
      <Flex className="">
        <Typography
          text="Terms and Conditions"
          type="title"
          className="text-2xl font-bold pb-4"
        />
      </Flex>
      <Flex vertical className="p-4">
        {TC_CONFIG.map((section, index) => (
          <Flex vertical key={index} className="  mb-4">
            <Typography {...section.heading} className="mt-4" />
            {Array.isArray(section.description.text) ? (
              section.description.text.map((text, i) => (
                <Typography
                  key={i}
                  text={text}
                  className={`text-gray-700 mt-2  ${section.description.className}`}
                  type={section.description.type}
                />
              ))
            ) : (
              <Typography
                text={section.description.text}
                className={`text-gray-700 mt-2  ${section.description.className}`}
                type={section.description.type}
              />
            )}
          </Flex>
        ))}
      </Flex>
      <Flex
        vertical
        justify="space-between"
        className=" sticky bottom-0  w-full text-white  "
      >
        <Flex
          justify="end"
          className={`sticky bottom-0 w-full lg:justify-between justify-end p-4 border-t h-[56px] md:h-[72px] border-[#7C30F7] ${
            isDark ? 'bg-primaryDark' : 'bg-primaryLight'
          } `}
        >
          <Button
            text="Back"
            onClick={() => {
              navigate(-1);
            }}
            buttonProps={{ type: 'primary-none' }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default TermsAndConditions;
